import { InputNumber } from "antd";
import AntInputNumber from "./styles/inputNumber.style";
import WithDirection from "../misc/theme/withDirection";

const WDInputnumber = AntInputNumber(InputNumber);
const Inputnumber = WithDirection(WDInputnumber);

export default Inputnumber;



// WEBPACK FOOTER //
// ./src/components/ui-ant/elements/inputNumber.js